<template>
  <v-container fluid class="icons-page">
    <h1 class="page-title mt-5 mb-6">สรุปรายการสั่งซื้อ</h1>

    <v-row no-gutters class="d-flex justify-space-between mt-10 mb-6">
      <v-col cols="12" md="5">
        <v-menu
          v-model="fromdate"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :error-messages="fromdateError"
              required
              :value="computedFromDate"
              clearable
              label="วันที่"
              readonly
              v-bind="attrs"
              v-on="on"
              @click:clear="search.fromdate = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="search.fromdate"
            @change="fromdate = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="5">
        <v-menu
          v-model="todate"
          :close-on-content-click="false"
          max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :error-messages="todateError"
              :value="computedTodate"
              clearable
              label="วันที่"
              readonly
              v-bind="attrs"
              v-on="on"
              @click:clear="search.todate = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="search.todate"
            @change="todate = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="1">
        <div class="justify-right">
          <v-btn class="mx-1" large fab color="primary" @click="searchdata">
            <v-icon>mdi-file-find</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card>
      <v-row>
        <v-col cols="12">
          <div class="float-md-right">
            <v-text-field
              v-model="table.search"
              append-icon="mdi-magnify"
              label="Filter"
              single-line
              hide-details
            ></v-text-field>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table
            v-model="table.selected"
            :headers="table.headers"
            :items="table.desserts"
            item-key="orderId"
            :search="table.search"
            :loading="table.loading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:[`item.orderId`]="{ item }">
              <a @click="orderId(item.orderId)" class="primary--text">
                {{ item.orderId }}
              </a>
            </template>

            <template v-slot:[`item.createDate`]="{ item }">
              {{ formatDate(item.createDate) }}
            </template>

            <template v-slot:[`item.duedate`]="{ item }">
              {{ formatDate(item.duedate) }}
            </template>
            <template v-slot:[`item.statusDesc`]="{ item }">
              <a @click="showmodalstatus(item.orderId)" class="primary--text">
                {{ item.statusDesc }}
              </a>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                :disabled="item.statusDoc != 'N'"
                small
                @click="cancel(item.orderId, item)"
                color="red"
              >
                mdi-cancel
              </v-icon>
            </template>

            -->
          </v-data-table>
        </v-col>
      </v-row>

      <!--modal status-->
      <v-row>
        <v-dialog
          v-model="modalstatus"
          scrollable
          max-width="500px"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-card>
            <v-card-title>
              <span class="headline">รายละเอียดสถานะ</span>
            </v-card-title>
            <v-card-text>
              <v-container class="border">
                <v-data-table
                  v-model="tablestatus.selected"
                  :headers="tablestatus.headers"
                  :items="tablestatus.desserts"
                  item-key="StatusId"
                >
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:[`item.statusDate`]="{ item }">
                    {{ formatDateTime(item.statusDate) }}
                  </template>

                  <template v-slot:[`item.statusDesc`]="{ item }">
                    <a
                      @click="showstatusDetail(item)"
                      v-if="
                        item.statusId != 'N' &&
                          item.statusId != 'C' &&
                          item.statusId != 'Y' &&
                          item.statusId != 'A'
                      "
                      class="primary--text"
                    >
                      {{ item.statusDesc }}
                    </a>
                    <p v-else>{{ item.statusDesc }}</p>
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modalstatus = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- modal status Detail-->
      <v-row>
        <v-dialog
          v-model="modalStatusDetail"
          scrollable
          max-width="600px"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-card>
            <v-card-title>
              <span class="headline">ข้อมูลใบสั่งขาย</span>
            </v-card-title>
            <v-card-text>
              <v-container class="border">
                <v-data-table
                  :headers="tableStatusDetail.headers"
                  :items="tableStatusDetail.desserts"
                  item-key="StatusId"
                >
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:[`item.docDate`]="{ item }">
                    {{ formatDate(item.docDate) }}
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="modalStatusDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!--modal Delivery-->

      <v-row>
        <v-dialog
          v-model="modalStatusDelivery"
          scrollable
          max-width="600px"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-card>
            <v-card-title>
              <span class="headline">รายละเอียดจัดส่ง</span>
            </v-card-title>
            <v-card-text>
              <v-container class="border">
                <v-col cols="12">
                  <v-text-field
                    :value="computedtransDate"
                    label="วันที่จัดส่ง"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.docEntry"
                    label="Draft No"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.transName"
                    label="ตัวแทนขนส่ง"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="data.trackingNo"
                    label="Tracking No."
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.transNumber"
                    label="ทะเบียน"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.tel"
                    label="เบอร์โทร"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model.number="data.boxCount"
                    label="จำนวนบรรจุ"
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="data.other"
                    label="อื่น ๆ "
                    hide-details="auto"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="data.fileName != ''">
                  <a @click="ShowPicture()" class="primary--text">
                    แสดงรูปภาพ
                  </a>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="modalStatusDelivery = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-card>

    <v-dialog
      v-model="dialogimage"
      scrollable
      max-width="550px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <!--
        <v-card-title>
          <span class="headline">รายละเอียดจัดส่ง</span>
        </v-card-title>
        -->

        <v-card-text>
          <v-container>
            <v-row align-content="center">
              <v-col cols="12">
                <v-img
                  :src="imageitem"
                  contain
                  height="360"
                  width="480"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogimage = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
export default {
  data: () => ({
    fromdate: "",
    todate: "",
    search: {
      fromdate: "",
      todate: "",
    },
    table: {
      search: "",
      selected: [],
      loading: false,
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "index",
          //  width: "10%",
        },
        {
          text: "เลขใบสั่งซื้อ",

          sortable: true,
          value: "orderId",
          //  width: "10%",
        },

        {
          text: "วันที่เอกสาร",
          sortable: true,
          value: "createDate",
          //  width: "10%",
        },
        {
          text: "วันที่นัดส่ง",
          sortable: true,
          value: "duedate",
          //   width: "10%",
        },
        {
          text: "หมายเหตุ",
          value: "remark",
        },
        {
          text: "ผู้ติดต่อ",
          sortable: true,
          value: "name",
          width: "20%",
        },
        {
          text: "สถานะ",
          sortable: true,
          value: "statusDesc",
          //   width: "15%",
        },
        { text: "ยกเลิก", value: "actions" },
      ],

      desserts: [],
    },

    imageitem: "",
    dialogimage: false,

    tablestatus: {
      search: "",
      selected: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "index",
          //  width: "10%",
        },
        {
          text: "วันที่",
          //align: "start",
          sortable: true,
          value: "statusDate",
          //  width: "10%",
        },
        {
          text: "สถานะ",
          //align: "start",
          sortable: true,
          value: "statusDesc",
          //  width: "10%",
        },
      ],
      desserts: [],
    },

    tableStatusDetail: {
      search: "",
      selected: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: true,
          value: "index",
          //  width: "10%",
        },
        {
          text: "วันที่",
          //align: "start",
          sortable: true,
          value: "docDate",
          //  width: "10%",
        },
        {
          text: "เลขใบสั่งขาย",
          //align: "start",
          sortable: true,
          value: "saleOrder",
          //  width: "10%",
        },
        {
          text: "Draft No",
          sortable: true,
          value: "draftNo",
        },
      ],
      desserts: [],
    },

    modalstatus: false,
    modalStatusDetail: false,
    modalStatusDelivery: false,

    data: {
      docNo: "",
      transDate: "",
      transName: "",
      trackingNo: "",
      transNumber: "",
      tel: "",
      other: "",
      fileName: "",
      boxCount: "",
      docEntry: "",
    },
  }),

  computed: {
    computedFromDate() {
      return this.search.fromdate
        ? moment(this.search.fromdate).format("DD/MM/YYYY")
        : "";
    },

    computedTodate() {
      return this.search.todate
        ? moment(this.search.todate).format("DD/MM/YYYY")
        : "";
    },
    fromdateError() {
      const errors = [];
      if (!this.$v.search.fromdate.$dirty) return errors;
      !this.$v.search.fromdate.required && errors.push("กรุณาใส่วันที่");

      return errors;
    },

    todateError() {
      const errors = [];
      if (!this.$v.search.todate.$dirty) return errors;
      !this.$v.search.todate.required && errors.push("กรุณาใส่วันที่");

      return errors;
    },

    computedtransDate() {
      return this.data.transDate
        ? moment(this.data.transDate).format("DD/MM/YYYY")
        : "";
    },
  },

  validations: {
    search: {
      fromdate: { required },
      todate: { required },
    },
  },

  methods: {
    async searchdata() {
      this.table.desserts = [];
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
      this.table.loading = true;
      try {
        var params = new URLSearchParams();
        params.append("fromdate", this.search.fromdate);
        params.append("todate", this.search.todate);
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/GetHeader/" + localStorage.getItem("customerid"),
          params: params,
        });

        if (response.status == "200") {
          this.table.desserts = response.data.header;
        } else {
          this.$swal.fire({
            icon: "info",
            title: "ค้นหาข้อมูล",
            text: "ไม่พบข้อมูลการสั่งซื้อ",
          });
        }
      } catch (error) {
        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data.response.data,
          });
        }
      }
      this.table.loading = false;
    },
    formatDate(value) {
    return moment(value).add(543, 'years').format("DD/MM/YYYY");
    },
    formatDateTime(value) {
    return moment(value).add(543, 'years').format("DD/MM/YYYY HH:mm");
    },
    orderId(value) {
      this.$router.push("/Order/CreateOrder");
      this.$store.state.orderid = value;
    },
    /*
    ShowPicture() {
      // console.log(value);
      console.log(
        config.baseURL + '/api/CustomerOrder/GetTransPic/' + this.data.fileName,
      )
      this.$swal.fire({
        imageUrl:
          config.baseURL +
          '/' +
          'api/CustomerOrder/GetTransPic/' +
          this.data.fileName,
        imageHeight: 300,
        imageWidth: 480,
        // imageAlt: value,
      })
    },
    */

    async showmodalstatus(value) {
      this.tablestatus.desserts = [];

      try {
        let response = await this.$http({
          method: "get",
          url:
            "api/customerorder/GetStatus/" +
            localStorage.getItem("customerid") +
            "/" +
            value,
        });
        //  console.log(response);
        if (response.status == "200") {
          this.tablestatus.desserts = response.data.status;

          this.modalstatus = true;
        }
      } catch (error) {
        console.log(error);

        if (error.response != undefined) {
          if (error.response.status == "401") {
            this.$swal.fire({
              icon: "error",
              title: "Authorize",
              text: "ไม่พบสิทธิ์การใช้งาน",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: error.response.data,
          });
        }
      }
    },

    async showstatusDetail(value) {
      if (value.statusId == "O") {
        var detail = await this.$http({
          method: "get",
          url: "api/SaleOrderMemo/GetSaleOrderNumber/" + value.docRef,
        });

        if (detail.status == "200") {
          this.tableStatusDetail.desserts = detail.data.saleordermemodoc;

          this.modalStatusDetail = true;
        }
      } else if (value.statusId == "D") {
        var response = await this.$http({
          mothod: "get",
          url: "api/CustomerOrder/Transport/" + value.docRef,
        });

        if (response.status == "200") {
          this.data = response.data.data;
          this.modalStatusDelivery = true;
        }
      }
    },

    ShowPicture() {
      this.$http({
        method: "get",
        url: "api/customerorder/gettranspic/" + this.data.fileName,
        responseType: "arraybuffer",
      })
        .then((response) => {
          if (response.status == "200") {
            // var bytes = new Uint8Array(response.data)
            //var binary = bytes.reduce(
            //  (data, b) => (data += String.fromCharCode(b)),
            // '',
            // )
            //   this.imageitem = 'data:image/jpeg;base64,' + btoa(binary)

            const url = window.URL.createObjectURL(new Blob([response.data]));
            this.imageitem = url;
            this.dialogimage = true;
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            if (error.response.status == "401") {
              this.$swal.fire({
                icon: "error",
                title: "Authorize",
                text: "ไม่พบสิทธิ์การใช้งาน",
              });
            }
          } else {
            this.$swal.fire({
              icon: "error",
              text: error.response.data.response.data,
            });
          }
        });
    },

    async cancel(value, item) {
      this.$swal
        .fire({
          title: "ต้องการยกเลิกรายการนี้ใช่ไหม",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$http({
              method: "put",
              url:
                "api/customerorder/CancelOrder/" +
                localStorage.getItem("customerid") +
                "/" +
                value,
            })
              .then((response) => {
                if (response.status == "200") {
                  //this.searchdata();
                  item.statusDoc = "C";
                  item.statusDesc = "ยกเลิกใบสั่งซื้อ";
                }
              })
              .catch((error) => {
                if (error.response != undefined) {
                  if (error.response.status == "401") {
                    this.$swal.fire({
                      icon: "error",
                      title: "Authorize",
                      text: "ไม่พบสิทธิ์การใช้งาน",
                    });
                  }
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: error.response.data,
                  });
                }
              });
          }
        });
    },
  },
};
</script>

<style scope>
a {
  color: green;
  background-color: transparent;
  text-decoration: none;
}
</style>
